import { mapAtom } from '../../atoms/map/map'
import { findLayer } from '../utils/findLayer'

import { mapStylesUpdateGeofenceFeatures } from './utils/mapStylesUpdateGeofenceFeatures'

export const createUpdateGeofenceFeaturesMapStyleFromChangelog = (
  markers: uui.domain.ui.map.markers.MapMarkers['geofence'],
  mapStyles: uui.domain.ui.map.markers.MapStyles['geofence'],
  selection: Set<string>,
) => {
  // ATTENTION: Application of Map Style changes will not be cached if a delayed rendering mechanism will be implemented
  // After the whole set of delayed marker changelogs is applied a full refresh of Map Styles will be required

  return async () => {
    const map = mapAtom.map
    const layer = findLayer(map, 'geofence')

    // only the `update` field is populated in a mapStyles changelog
    await mapStylesUpdateGeofenceFeatures(layer, markers, mapStyles, selection)
  }
}
